// extracted by mini-css-extract-plugin
export default {"sortableHeader":"TableDark__sortableHeader___3qnVn"};